
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"0mm1hq300a","fill":"#fff"}},[_c('path',{attrs:{"d":"M12.898 5.702a5.63 5.63 0 015.627 5.451 3.573 3.573 0 01-.097 7.145H6.365a4.366 4.366 0 110-8.732H7.55a5.633 5.633 0 015.348-3.864z"}})]),_c('path',{attrs:{"d":"M12.898 5.702v-1 1zm5.627 5.451l-1 .032.03.943.943.025.027-1zm3.477 3.572h1-1zm-20.003-.792h-1 1zM7.55 9.566v1h.723L8.5 9.88l-.95-.314zm5.348-3.864v1a4.63 4.63 0 014.627 4.483l1-.032 1-.031a6.63 6.63 0 00-6.627-6.42v1zm5.627 5.451l-.027 1a2.573 2.573 0 012.503 2.572h2a4.573 4.573 0 00-4.45-4.571l-.026 1zm3.477 3.572h-1a2.573 2.573 0 01-2.574 2.573v2a4.573 4.573 0 004.573-4.573h-1zm-3.574 3.573v-1H6.365v2h12.063v-1zm-12.063 0v-1a3.366 3.366 0 01-3.366-3.365h-2a5.366 5.366 0 005.366 5.365v-1zm-4.366-4.365h1a3.367 3.367 0 013.366-3.367v-2a5.367 5.367 0 00-5.366 5.367h1zm4.366-4.367v1H7.55v-2H6.365v1zm1.185 0l.95.314a4.633 4.633 0 014.398-3.178v-2A6.633 6.633 0 006.6 9.252l.95.314z","fill":"currentColor","mask":"url(#0mm1hq300a)"}})])
          )
        }
      }
    